module.exports = __webpack_public_path__ + "img/dashuju.96c06a9f.jpg";